import { useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export const usePromptManagement = (callerUserId) => {
  const [prompts, setPrompts] = useState([]);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadModules = useCallback(async () => {
    if (!callerUserId) return;
    try {
      const res = await axios.get(`${API}/api/prompt/modules`, {
        params: { caller_user_id: callerUserId },
      });
      setModules(res.data.modules || []);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to load modules');
    }
  }, [callerUserId]);

  const loadPrompts = useCallback(async () => {
    if (!callerUserId) return;
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(`${API}/api/prompt/prompts`, {
        params: { caller_user_id: callerUserId },
      });
      setPrompts(res.data.prompts || []);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to load prompts');
    } finally {
      setLoading(false);
    }
  }, [callerUserId]);

  const createPrompt = useCallback(async (payload) => {
    try {
      const res = await axios.post(`${API}/api/prompt/prompts`, {
        caller_user_id: callerUserId,
        ...payload,
      });
      return { success: true, data: res.data };
    } catch (e) {
      return { success: false, error: e.response?.data?.error || 'Failed' };
    }
  }, [callerUserId]);

  const updatePrompt = useCallback(async (promptId, payload) => {
    try {
      const res = await axios.patch(
        `${API}/api/prompt/prompts/${promptId}`,
        { caller_user_id: callerUserId, ...payload },
      );
      return { success: true, data: res.data };
    } catch (e) {
      return { success: false, error: e.response?.data?.error || 'Failed' };
    }
  }, [callerUserId]);

  return {
    prompts, modules, loading, error, setError,
    loadModules, loadPrompts, createPrompt, updatePrompt,
  };
};
